import React from 'react';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import NoDataPlaceholder from 'components/common/general/NoDataPlaceholder';
import ResponseDocumentDelegate from 'store/pages/rfq/rfq-response/proposal-response/responseDocumentDelegate';
import { DocumentsSectionStyled, StyledListWrapper } from './styles';
import ResponseDocumentCard from '../ResponseDocumentCard';

interface Props {
  documents: ResponseDocumentDelegate[];
  loading: boolean;
}

const ResponseDocumentList: React.FC<Props> = observer(({ documents, loading = false }) => {
  const areDocumentsMissing = documents.length === 0;
  return (
    <DocumentsSectionStyled>
      <StyledListWrapper>
        <OverlaySpinner display={loading} />
        {areDocumentsMissing && !loading ? (
          <li>
            <NoDataPlaceholder text="No documents have been uploaded yet" />
          </li>
        ) : (
          documents.map((docDelegate) => (
            <ResponseDocumentCard key={docDelegate.document.id} documentDelegate={docDelegate} />
          ))
        )}
      </StyledListWrapper>
    </DocumentsSectionStyled>
  );
});

export default ResponseDocumentList;
